/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "components/ui/button";
import { format } from "date-fns";
import { MoreVerticalIcon } from "lucide-react";
import { StatusEnum } from "@/enum/status";
import { cn } from "@/lib/utils";
import DropdownMenuComponent from "../components/action-table";
import SortedCell from "../components/sorted-cell";

const muthedRow = (status: StatusEnum) => {
  return cn("w-full h-full px-[10px] py-[6px]", {
    "bg-[#F0F0F1]": status === StatusEnum.INACTIVE,
  });
};

const APPLIES_TO_LABELS: Record<string, string> = {
  NSU: "Apenas NSU",
  DIVERGENCE: "Apenas Divergência",
  BOTH: "Ambas",
};

export const columns = [
  {
    accessorKey: "name",
    header: ({ column }: { column: any }) => (
      <SortedCell key={"name"} column={column} title={"Justificativa"} />
    ),
    cell: ({ row }: { row: any }) => {
      return (
        <div className={muthedRow(row?.original?.status)}>
          {row?.original?.name}
        </div>
      );
    },
    className: "!p-0",
  },
  {
    accessorKey: "account.name",
    header: ({ column }: { column: any }) => (
      <SortedCell
        key={"account.name"}
        column={column}
        title={"Conta contábil"}
        orderName="justification_account"
      />
    ),
    cell: ({ row }: { row: any }) => {
      return (
        <div
          className={`flex justify-start ${muthedRow(row?.original?.status)}`}
        >
          {row.original.account.name}
        </div>
      );
    },
    className: "!p-0",
  },
  {
    accessorKey: "created_at",
    header: ({ column }: { column: any }) => (
      <SortedCell key={"created_at"} column={column} title={"Criado em"} />
    ),
    cell: ({ row }: { row: any }) => {
      const createdAt = row.original.created_at;
      const formattedDate = format(new Date(createdAt), "dd/MM/yyyy");
      return (
        <div
          className={`flex justify-start ${muthedRow(row?.original?.status)}`}
        >
          {formattedDate}
        </div>
      );
    },
    className: "!p-0",
  },
  {
    accessorKey: "updated_at",
    header: ({ column }: { column: any }) => (
      <SortedCell key={"updated_at"} column={column} title={"Atualizado em"} />
    ),
    cell: ({ row }: { row: any }) => {
      const updatedAt = row.original.updated_at;
      const formattedDate = updatedAt
        ? format(new Date(updatedAt), "dd/MM/yyyy")
        : "--";
      return (
        <div
          className={`flex justify-start ${muthedRow(row?.original?.status)}`}
        >
          {formattedDate}
        </div>
      );
    },
    className: "!p-0",
  },
  {
    accessorKey: "is_previous_day",
    header: ({ column }: { column: any }) => (
      <SortedCell
        key={"is_previous_day"}
        column={column}
        title={"Referente Ao Dia Anterior"}
      />
    ),
    cell: ({ row }: { row: any }) => {
      return (
        <div
          className={`flex justify-start ${muthedRow(row?.original?.status)}`}
        >
          {row.original.is_previous_day ? "Sim" : "Não"}
        </div>
      );
    },
    className: "!p-0",
  },
  {
    accessorKey: "is_next_day",
    header: ({ column }: { column: any }) => (
      <SortedCell
        key={"is_next_day"}
        column={column}
        title={"Referente Ao Dia Seguinte"}
      />
    ),
    cell: ({ row }: { row: any }) => {
      return (
        <div
          className={`flex justify-start ${muthedRow(row?.original?.status)}`}
        >
          {row.original.is_next_day ? "Sim" : "Não"}
        </div>
      );
    },
    className: "!p-0",
  },
  {
    accessorKey: "applies_to",
    header: ({ column }: { column: any }) => (
      <SortedCell
        key={"applies_to"}
        column={column}
        title={"Aplicável em"}
      />
    ),
    cell: ({ row }: { row: any }) => {
      return (
        <div
          className={`flex justify-start ${muthedRow(row?.original?.status)}`}
        >
          {APPLIES_TO_LABELS[row.original.applies_to] || row.original.applies_to}
        </div>
      );
    },
    className: "!p-0",
  },
  {
    accessorKey: "can_close_with_surplus",
    header: ({ column }: { column: any }) => (
      <SortedCell
        key={"can_close_with_surplus"}
        column={column}
        title={"Pode Fechar com Falta"}
      />
    ),
    cell: ({ row }: { row: any }) => {
      return (
        <div
          className={`flex justify-start ${muthedRow(row?.original?.status)}`}
        >
          {row.original.can_close_with_surplus ? "Sim" : "Não"}
        </div>
      );
    },
    className: "!p-0",
  },
  {
    id: "actions",
    header: () => <div> Ações </div>,
    cell: ({ row }: { row: any }) => {
      return (
        <div
          className={`w-full flex items-center justify-center ${muthedRow(
            row?.original?.status
          )}`}
        >
          <DropdownMenuComponent
            row={row?.original}
            trigger={
              <Button
                variant="link"
                className="p-0 m-0 h-[0px] flex items-center justify-center"
              >
                <MoreVerticalIcon className="w-[20px]" />
              </Button>
            }
          />
        </div>
      );
    },
    className: "!p-0 w-[50px] items-center justify-center",
  },
];
